export enum RoleEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ISSUER_ADMIN = 'ISSUER_ADMIN',
  EO_ADMIN = 'EO_ADMIN',
  EO_USER = 'EO_USER',
  READ_ONLY = 'READ_ONLY',
  HELP_DESK = 'HELP_DESK',
  PRODUCTION_REQUEST = 'PRODUCTION_REQUEST',
  STAMPS_PARTNER = 'STAMPS_PARTNER',
  STANDARD_USER = 'STANDARD_USER'
}
